// token 存储名称
export const TOKEN_STORE_NAME = "_act";
// 开启页签是否缓存组件
export const TAB_KEEP_ALIVE = true;

// 开启 KeepAlive 后仍然不需要缓存的路由地址
export const KEEP_ALIVE_EXCLUDES: string[] = [];

// 直接指定菜单数据
export const USER_MENUS: Array<any> | undefined = undefined;

// 额外的菜单数据
export const EXTRA_MENUS: any = [];

export const PROVIDE_KEY: string = "EleGlobalConfig";

// 模块首页路径, 为空则取第一个菜单的地址
export const HOME_PATH: string | undefined = undefined;

// 外层布局的路由地址
export const LAYOUT_PATH = "/";

// 刷新路由的路由地址
export const REDIRECT_PATH = "/redirect";

// 存储用户信息
export const USER_INFO = "user_info";

// 不需要登录的路由
export const WHITE_LIST: string[] = ["/login", "/forget"];

// 应用名称
export const APPLICATION_NAME: string = "优质采招标采购平台";

// 页签同路由不同参数可重复打开的路由
export const REPEATABLE_TABS: string[] = [];

// 弹框表格大小
export const Table_SIZE: string = "small";
// 表单大小
export const FORM_SIZE: string = "default";

// 弹框宽度大小
export const MODAL_SMALL_WIDTH = 400;
export const MODAL_MIDDLE_WIDTH = 600;

// 弹窗高度
export const MODAL_SMALL_BODY = {
  overflowY: "auto",
  height: "160px",
};
export const MODAL_MIDDLE_BODY = {
  overflowY: "auto",
  height: "280px",
};
export const MODAL_BIG_BODY = {
  overflowY: "auto",
  height: "490px",
};

export const MENU_DATA_DEFAULT = {
  code: 0,
  message: "操作成功",
  data: [
    {
      menuId: 1001,
      parentId: 0,
      title: "首页",
      path: "/home",
      component: "/site-home",
      menuType: 0,
      sortNumber: 1,
      authority: null,
      icon: "file-text-outlined",
      hide: 0,
      meta: null,
      deleted: 0,
      tenantId: 2,
      createTime: "2021-02-02 20:03:51",
      updateTime: "2022-03-11 15:40:07",
      children: null,
      checked: null,
    },
  ],
};
